import { IconX } from "@tabler/icons-react";
import { Button, Typography, Combobox, ButtonProps } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { Criterion } from "./testCaseFormTypes";

interface CriteriaSectionProps {
  criteria: Criterion[];
  availableCriteria?: Array<{
    id?: string;
    name?: string;
    description?: string;
  }>;
  onAdd: (name: string, description: string) => void;
  onRemove: (index: number) => void;
}

export const CriteriaSection: React.FC<CriteriaSectionProps> = ({
  criteria,
  availableCriteria,
  onAdd,
  onRemove,
}) => {
  return (
    <div>
      <Typography variant="body" weight="medium" className="al-mb-2 al-block">
        Evaluation Criteria
      </Typography>

      {criteria.length > 0 && (
        <Stack direction="row" className="al-flex-wrap al-gap-2 al-mb-3">
          {criteria.map((criterion, index) => (
            <div
              key={index}
              className="al-inline-flex al-items-center al-gap-2 al-bg-purple-100 al-text-purple-700 al-px-3 al-py-1.5 al-rounded-full al-text-sm al-font-medium al-border al-border-purple-300"
            >
              <span>{criterion.name}</span>
              <Button
                onClick={() => onRemove(index)}
                variant="ghost"
                size="icon"
                title="Remove criterion"
                type="button"
                className="al-h-6 al-w-6 al-text-purple-600 hover:al-text-purple-800"
              >
                <IconX size={16} />
              </Button>
            </div>
          ))}
        </Stack>
      )}

      <Combobox
        id="test-case-criteria-selector"
        value=""
        options={
          availableCriteria
            ?.filter((crit) => !criteria.some((c) => c.name === crit.name))
            .map((crit) => ({
              label: crit.name || "",
              value: crit.id || "",
            })) || []
        }
        onChange={(value: string) => {
          const selectedCriterion = availableCriteria?.find(
            (c) => c.id === value,
          );
          if (selectedCriterion?.name && selectedCriterion?.description) {
            onAdd(selectedCriterion.name, selectedCriterion.description);
          }
        }}
        placeholder="Add criterion from saved..."
        buttonProps={
          {
            variant: "outline",
            className:
              "al-w-full al-border-purple-300 al-bg-purple-50 hover:al-border-purple-400 focus:al-border-purple-400 focus:al-ring-2 focus:al-ring-purple-100",
          } as ButtonProps
        }
        popoverContentProps={{
          className: "al-bg-purple-50 al-border-purple-300",
        }}
      />
    </div>
  );
};
